<template>
	<v-card flat class="mt-4">
		<v-card-text>
			<v-select 
				v-model="aggregateBy" 
				label="Aggregate data values by:" 
				filled rounded :items="columnOptions"></v-select>
			<v-data-table :headers="headers" :items="items">
				<template v-slot:footer.prepend>
					<export
						:columns="headers"
						:rows="items"
						name="staff-survey-overview"
						icon
					></export>
				</template>
			</v-data-table>
		</v-card-text>
	</v-card>
</template>

<script>
import Export from "@c/downloads/Export";
export default {
	name: "ResponseTable",
	props: {
		id: { type: String }, // the ID of the staff survey
		responsesInDateRange: { type: Array }
	},
	components: {
		Export,
	},
	data: () => {
		return {
			columnOptions: [
				{text: "Service", value: "services"},
				{text: "Job Role", value: "jobFunctions"},
				{text: "Tag", value: "tags"},
			],
			aggregateBy: "jobFunctions",
			aggregationSource: {
				services: "service",
				jobFunctions: "jobFunction",
				tags: "tags",
			}
		}
	},
	computed: {
		organisation() {
			return this.$store.state.organisation.data
		},
		categoryOptions() {
			return this.$store.state.categoryOptions.data;
		},		
		providerType() {
			const id = this.organisation.provider[0];
			if( !id ){
				return null;
			}
			return this.$store.state.categoryOptions.data[id]
		},
		serviceOptions() {
			return this.providerType ? this.providerType.services : []
		},
		services(){
			const self = this;
			return self.serviceOptions.map( option => self.categoryOptions[option])
		},
		tags(){
			return this.$store.getters["staffSurveyTags/forOrganisation"](this.organisation.id)
		},
		jobFunctions() {
			return this.$store.getters["jobFunctions/options"];
		},
		responses() {
			return this.$store.state.staffSurveyResponses.data;
		},
		section() {
			return this.$store.state.sections.data[this.id];
		},
		questions() {
			const self = this;
			if (!self.section) {
				return [];
			} else {
				return self.section.questions.map((a) => {
					return self.$store.state.questions.data[a];
				}).filter( q => q.is_scored );
			}
		},
		questionTemplates() {
			return this.$store.state.questionTemplates.data;
		},
		indicators() {
			return this.$store.state.indicators.data;
		},
		headers() {
			var self = this;
			var headers = [
				{ value: "question", text: "Question" },
				{ value: "section", text: "Section" }
			];
			self[this.aggregateBy].forEach((j) => {
				headers.push({ value: j.id, text: j.name });
			});
			return headers;
		},
		responsesByQuestion() {
			const self = this;
			return Object.fromEntries(
				self.section.questions.map((q) => {
					return [q, self.responsesInDateRange.filter((r) => r.question == q)];
				})
			);
		},
		averageAnswerByQuestion() {
			const self = this;
			let questions = self.section.questions.filter((q) => {
				let answerOptions = self.$store.getters[
					"questions/getAnswerOptions"
				](q);
				return answerOptions;
			});
			return Object.fromEntries(
				questions.map((q) => {
					let averages = {};
					let answerOptions = self.$store.getters[
						"questions/getAnswerOptions"
					](q);
					let responses = self.responsesByQuestion[q];
					let source = self.aggregationSource[self.aggregateBy];
					self[self.aggregateBy].forEach((opt) => {
						let cols = responses.filter(
							(a) => a[source] && a[source].includes(opt.id)
						);
						let average = self.mwsurveyutils.averageResponse(
							cols,
							Object.values(answerOptions)
						);
						averages[opt.id] = average;
					});
					return [q, averages];
				})
			);
		},
		items() {
			const self = this;
			let responses = self.averageAnswerByQuestion;
			return Object.keys(responses).map((question) => {
				let r = { ...responses[question] };
				r.question_id = question;
				let questionTexts = self.$store.getters["questions/getQuestionTexts"]( question ) 
                r.question = questionTexts.string;
				return r;
			});
		},
	},
	methods: {},
};
</script>
